import { AbstractCommand } from 'src/models/command';

class DeleteUserFCMDeviceToken extends AbstractCommand {
	readonly name = 'IFS_User_Command_Command_DeleteUserFCMDeviceToken';

	public constructor(fcmDeviceToken: string) {
		super();
		this.parameters = {
			deviceToken: fcmDeviceToken,
		};
	}
}

export { DeleteUserFCMDeviceToken };
